import type React from 'react';

export const getImageFileFromClipboard = (
    event: React.ClipboardEvent<HTMLTextAreaElement | HTMLInputElement> | ClipboardEvent
): File | null => {
    const clipboardData = 'clipboardData' in event ? event.clipboardData : null;
    if (!clipboardData) return null;
    const files = Array.from(clipboardData.files || []);
    const imageFile = files.find((file) => file.type.startsWith('image/'));
    if (imageFile) return imageFile;
    const items = Array.from(clipboardData.items || []);
    const imageItem = items.find(
        (item) => item.kind === 'file' && item.type.startsWith('image/')
    );
    return imageItem?.getAsFile() || null;
};

export const insertTextAtCursor = (
    target: HTMLTextAreaElement | HTMLInputElement,
    currentValue: string,
    insertText: string,
    setValue: (value: string) => void
) => {
    const start = typeof target.selectionStart === 'number' ? target.selectionStart : currentValue.length;
    const end = typeof target.selectionEnd === 'number' ? target.selectionEnd : currentValue.length;
    const next = currentValue.slice(0, start) + insertText + currentValue.slice(end);
    setValue(next);
    requestAnimationFrame(() => {
        const cursor = start + insertText.length;
        try {
            target.setSelectionRange(cursor, cursor);
        } catch {
            // ignore selection errors
        }
    });
};
